// Display formatting for the commitment cancel screens. med-billing-engine sends money in whole
// currency units (dollars): 548 → "$548", 274.5 → "$274.50".

export function formatMoney(amount: number | null | undefined, currency = 'USD'): string {
	if (typeof amount !== 'number') return '—'
	const whole = Number.isInteger(amount)
	try {
		return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency,
			minimumFractionDigits: whole ? 0 : 2,
			maximumFractionDigits: 2,
		}).format(amount)
	} catch {
		return `${currency} ${amount.toFixed(whole ? 0 : 2)}`
	}
}

/** "Nov 30, 2026" (`long`: "November 30, 2026"; `short`: "Nov 30"). */
export function formatDate(iso: string | null | undefined, style: 'medium' | 'long' | 'short' = 'medium'): string {
	if (!iso) return '—'
	const d = new Date(iso)
	if (Number.isNaN(d.getTime())) return iso
	if (style === 'short') return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
	return d.toLocaleDateString('en-US', { month: style === 'long' ? 'long' : 'short', day: 'numeric', year: 'numeric' })
}

/** "Nov 2 and Nov 30" / "Nov 2, Nov 30 and Dec 28" (`medium`: "Nov 2, 2026 and Nov 30, 2026"). */
export function joinDates(isos: string[], style: 'short' | 'medium' = 'short'): string {
	const dates = isos.map((iso) => formatDate(iso, style))
	if (dates.length <= 1) return dates.join('')
	return `${dates.slice(0, -1).join(', ')} and ${dates[dates.length - 1]}`
}

/** "1 month" / "2 months". */
export function pluralize(count: number, word: string): string {
	return `${count} ${count === 1 ? word : `${word}s`}`
}
